var storage = {
    get: (key) => {
        try {
            const json = localStorage.getItem(key);
            return json ? JSON.parse(json) : '';
        }
        catch (error) {
            return '';
        }
    },
    set: (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            // Ignore
        }
    },
};

export { storage as default };
//# sourceMappingURL=storage.js.map
